module.exports = __webpack_public_path__ + "static/media/danxuanfuxuan.dab72da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/yysChargingOperator/share/images/danxuanfuxuan.png
// module id = 1221
// module chunks = 0